<template>
  <div class="user-select" :class="{ 'is-empty': !name }">
    <i v-if="!name" class="icon-search-line t-iconfont" @click="drawer = true"></i>
    <div class="title" @click="drawer = true">
      {{ name || '搜索员工' }}
    </div>
    <i v-if="name" class="icon-close-circle-line t-iconfont" @click="handleClearUser"></i>
    <el-drawer v-model="drawer" direction="btt" :show-close="false" size="80%" :with-header="false">
      <div class="drawer-content">
        <div class="head">
          <div class="left"></div>
          <div class="center">员工</div>
          <div class="right">
            <i class="icon-close-line t-iconfont" @click="drawer = false"></i>
          </div>
        </div>
        <div class="content">
          <van-cell-group inset>
            <van-field
              v-model="nameLike"
              clearable
              placeholder="搜索员工"
              @clear="handleClearSearch"
              @update:model-value="handleSearchInput"
            />
          </van-cell-group>
          <div v-if="userList.length" v-loading="searchLoading" class="user-select-content">
            <div
              v-for="item in userList"
              :key="item.id"
              class="user-item"
              @click="handleSelectUser(item)"
            >
              <img
                v-if="item.avatar && !item.avatar.includes('default.jpg')"
                alt=""
                class="avatar"
                :src="item.avatar"
              />
              <img v-else alt="" class="avatar" :src="userDefault" />
              <span v-html="addNodeByWX(item.name)"></span>
            </div>
          </div>
          <div v-else v-loading="searchLoading" class="user-select-empty">未找到该员工</div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { geuUserList } from '@/api/ai-board'
import userDefault from '@/assets/user-default.png'
import { addNodeByWX } from '@/utils/wx-node.js'

const props = defineProps({
  value: {
    type: [Number, String],
    default: ''
  },
  departmentId: {
    type: [Number, String],
    default: ''
  },
  isReview: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(['update:value', 'departChange'])

const drawer = ref(false)
const nameLike = ref('')
const searchLoading = ref(true)
const userList = ref([])
const timeout = ref(null)
const name = ref('')

const handleClearUser = () => {
  name.value = ''
  emits('update:value', '')
  emits('selectUser', null)
}

const handleSearchInput = () => {
  searchLoading.value = true
  clearTimeout(timeout.value)
  timeout.value = setTimeout(() => {
    getUserList(nameLike.value)
  }, 500)
}

const handleSelectUser = (item) => {
  name.value = item.name
  emits('update:value', item.userId)
  emits('selectUser', item)
  drawer.value = false
}

const getUserList = (name) => {
  const params = {
    pageSize: 20,
    page: 1,
    nameLike: name
  }
  if (!props.isReview) {
    params.assistantAlias = 'meeting'
  }
  geuUserList(params)
    .then((res) => {
      userList.value = res.result.userList
    })
    .catch((err) => {
      console.log(err)
    })
    .finally(() => {
      searchLoading.value = false
    })
}

const handleClearSearch = () => {
  nameLike.value = ''
}

onMounted(() => {
  getUserList()
})
</script>

<style lang="scss" scoped>
.user-select {
  flex: 0 0 auto;
  width: 132px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #f7f8fa;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: PingFang SC;
  font-size: 14px;
  line-height: 20px;
  color: #323233;
  .title {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  :deep(.el-drawer) {
    border-radius: 20px 20px 0px 0px;
  }
  .drawer-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
    .left {
      flex: 0 0 52px;
    }
    .right {
      flex: 0 0 52px;
      text-align: right;
      color: #969799;
      font-size: 20px;
    }
    .head {
      flex: 0 0 auto;
      overflow: hidden;
      text-align: center;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 13px 16px;
      /* 三级文字/常规 */
      font-family: PingFang SC;
      font-size: 16px;
      line-height: 22px;

      color: #323233;
    }
    .content {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      :deep(.van-field) {
        background: #f7f8fa;
      }
      :deep(.van-cell) {
        padding: 6px 16px;
      }
      :deep(.van-cell-group--inset) {
        flex: 0 0 auto;
        margin: 12px;
      }
      .user-select-content {
        flex: 1;
        overflow-y: auto;
        padding: 16px;
        .user-item {
          display: flex;
          align-items: center;
          padding: 6px 0;
          box-sizing: border-box;
          .avatar {
            flex: 0 0 auto;
            margin-right: 8px;
          }
          img {
            width: 24px;
            height: 24px;
            border-radius: 4px;
          }
          span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .user-select-empty {
        padding: 16px;
        text-align: center;
      }
    }
  }
}
.is-empty {
  .title {
    margin-left: 8px;
    font-family: PingFang SC;
    font-size: 14px;
    line-height: 20px;
    color: #c8c9cc;
  }
  i {
    color: #c8c9cc;
  }
}
</style>
